import * as React from 'react';
import { useDispatch } from 'react-redux';

import { TThunkDispatch } from '../../../../../store';
import { IFrequencyParams, updateSubscriptionFrequency } from '../../../../../store/subscriptions';
import { Dropdown, TDropdownProps } from '../../../../base/Dropdown';

type TFrequencyContainerProps = Pick<
  TDropdownProps,
  'itemId' | 'isEnabled' | 'options' | 'selectedValue' | 'categoryName'
>;

export const FrequencyContainer: React.FC<TFrequencyContainerProps> = props => {
  const dispatch = useDispatch<TThunkDispatch>();

  const handleChange = React.useCallback(
    (params: IFrequencyParams) => {
      dispatch(updateSubscriptionFrequency(params));
    },
    [dispatch],
  );

  if (!props.options.length) {
    return null;
  }

  return <Dropdown {...props} onChange={handleChange} />;
};
